/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LightbulbIcon16Light } from './LightbulbIcon16Light';
import { LightbulbIcon16Regular } from './LightbulbIcon16Regular';
import { LightbulbIcon16Solid } from './LightbulbIcon16Solid';
import { LightbulbIcon20Light } from './LightbulbIcon20Light';
import { LightbulbIcon20Regular } from './LightbulbIcon20Regular';
import { LightbulbIcon20Solid } from './LightbulbIcon20Solid';
import { LightbulbIcon24Regular } from './LightbulbIcon24Regular';
import { LightbulbIcon24Solid } from './LightbulbIcon24Solid';
import { LightbulbIcon32Regular } from './LightbulbIcon32Regular';
import { LightbulbIcon64Regular } from './LightbulbIcon64Regular';
var sizes = {
    16: {
        light: LightbulbIcon16Light,
        regular: LightbulbIcon16Regular,
        solid: LightbulbIcon16Solid,
    },
    20: {
        light: LightbulbIcon20Light,
        regular: LightbulbIcon20Regular,
        solid: LightbulbIcon20Solid,
    },
    24: {
        regular: LightbulbIcon24Regular,
        solid: LightbulbIcon24Solid,
    },
    32: {
        regular: LightbulbIcon32Regular,
    },
    64: {
        regular: LightbulbIcon64Regular,
    },
};
export var LightbulbIcon = forwardRef('LightbulbIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
